module.exports = __webpack_public_path__ + "static/media/refund-policy.b3eb67f4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/refund-policy.pdf
// module id = 285
// module chunks = 0